import React from "react";
import { SvgIcon } from "@mui/material";
import { cleanIconProps } from "./cleanIconProps";

const HourglassIcon = (props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      {...cleanIconProps(props)}
    >
      <circle
        style={{ ...props.circleStyle }}
        className="leaves-1"
        cx="150"
        cy="151.08244"
        r="109.58458"
      />
      <g transform="scale(6), translate(13 13)">
        <g fill="#fff">
          <path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" />
        </g>
      </g>
    </SvgIcon>
  );
};

export default HourglassIcon;
